import React, { PropsWithChildren, useMemo } from "react";
import { KnopClientContext } from "./KnopClientContext";
import { KnopClient } from "@opstel/query/knopClient";

interface KnopClientProviderProps extends PropsWithChildren {
  readonly knopClient: KnopClient;
}

export function KnopClientProvider({
  knopClient,
  children,
}: KnopClientProviderProps): React.JSX.Element {
  const props = useMemo(() => ({ knopClient }), [knopClient]);
  return <KnopClientContext.Provider value={props}>{children}</KnopClientContext.Provider>;
}
